module.exports = __webpack_public_path__ + "static/media/mariposa-corte-03.5684b0c0.png";